export default "__VITE_ASSET__BiQbjL3J__"